import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { Login_Page } from "../../Configuration/API_URL";
import { Link } from "react-router-dom";
import Formnav from "./FormNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Constants } from "../../CommonMethhods/Constants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  AESEncryption,
  ApiResDecrypt,
  onlyAlphaNumeric,
  onlyNumber,
} from "../../CommonMethhods/CommonMethods";

function ForgetTelePasswordForm() {
  let navigate = useNavigate();
  // const [userError, setUserError] = useState(false);
  const [passwordPage, setPasswordPage] = useState(false);
  const [useIdSet, SetUserId] = useState("");
  const forgotUserSchema = Yup.object().shape({
    userId: Yup.string().required("Enter your user ID"),
  });

  const {
    register: registerUser,
    handleSubmit: handelUser,
    formState: { errors: userError },
    reset: resetUser,
  } = useForm({
    resolver: yupResolver(forgotUserSchema),
  });

  const changePasswordSchema = Yup.object().shape({
    password: Yup.string()
      .required("Enter your new Password")
      .min(8, "Minimum character should be 8 and above.")
      .matches(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$",
        "Password must contain lower case,upper case,number and special character."
      ),
    otp: Yup.string()
      .required("Enter your OTP")
      .min(4, "OTP must be at least 4 Digit"),
  });

  const {
    register: registerNewPassword,
    handleSubmit: handelPassword,
    formState: { errors: changePassError },
    reset: resetPass,
  } = useForm({
    resolver: yupResolver(changePasswordSchema),
  });

  // api call to change password

  const submitUser = (value) => {
    SetUserId(value.userId);
    forgotPasswordApi(value.userId);
  };
  const forgotPasswordApi = async (value) => {
    let payloadValue = {
      userId: value,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getToken = await axios.post(
        Login_Page.Forgot_PasswordV3,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 1,
          },
        }
      );
      let responseEnc = ApiResDecrypt(getToken?.data);
      if (responseEnc?.status == 1) {
        toast.error(responseEnc?.message);
        console.log(responseEnc?.message);
        setPasswordPage(false);
      } else {
        console.log(responseEnc, "forgot");
        toast.success(responseEnc?.data);
        setPasswordPage(true);
        resetUser();
        resetPass();
      }
      // if (getToken.data.message == "Failed to send otp") {
      //     toast.error(getToken.data.message);
      // } else {

      // }
    } catch (error) {
      console.log(error);
    }
  };

  const submitPassword = (value) => {
    changePasswordApi(value);
  };

  const changePasswordApi = async (value) => {
    let payloadChangeValue = {
      userId: useIdSet,
      otp: value.otp,
      newPassword: value.password,
    };
    console.log(payloadChangeValue, "change");
    let encPayloadChangePass = AESEncryption(payloadChangeValue);

    try {
      const getToken = await axios.post(
        Login_Page.Forgot_ChangePasswordV2,
        `"${encPayloadChangePass}"`,
        {
          headers: {
            "Content-Type": "application/json",
            reserv: 1,
          },
        }
      );
      let responseEncChangepass = ApiResDecrypt(getToken?.data);
      if (responseEncChangepass.status == 1) {
        toast.error(responseEncChangepass.message);
      } else {
        toast.success(responseEncChangepass.data.message);
        setPasswordPage(true);
        navigate("/");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="form-wrapper">
        {passwordPage ? (
          <form
            className="form login-form mt-5"
            onSubmit={handelPassword(submitPassword)}
          >
            <Formnav />
            <h2 className="form-title">{Constants.Forgot_Pass}</h2>
            {/* <h4 className="form-info">{Constants.Password_Reset_Link}</h4> */}
            <h4 className="form-info">
              OTP sent to your register mobile number and email
            </h4>
            <label htmlFor="name" className="form-label">
              {"Enter New Password"}
              <span className="mandatory-label">*</span>
            </label>
            <input
              type="text"
              // name="userID"
              className="form-input"
              placeholder="Enter New Password"
              // onChange={handleUserId}
              maxLength={20}
              onInput={(e) => (e.target.value = e.target.value.trim())}
              {...registerNewPassword("password")}
            />
            <p className="forget-link">
              <span className="text-left">
                {changePassError?.password?.message}
              </span>
              <Link to="/">{Constants.Back_Login}</Link>
            </p>
            <label htmlFor="name" className="form-label">
              {"OTP"}
              <span className="mandatory-label">*</span>
            </label>
            <input
              type="text"
              // name="userID"
              className="form-input"
              placeholder="Enter OTP"
              maxLength={4}
              onInput={onlyNumber}
              {...registerNewPassword("otp")}
            />
            <p className="forget-link">
              <span>{changePassError?.otp?.message}</span>
            </p>

            <button className="form-submit" type="submit">
              {Constants.Submit}
            </button>
          </form>
        ) : (
          <form
            className="form login-form"
            onSubmit={handelUser(submitUser)}
            noValidate
          >
            <Formnav />
            <h2 className="form-title">{Constants.Forgot_Pass}</h2>
            <h4 className="form-info">{Constants.Password_Reset_Link}</h4>
            <label htmlFor="name" className="form-label">
              User ID<span className="mandatory-label">*</span>
            </label>
            <input
              type="text"
              // name="userID"
              className="form-input"
              placeholder="Enter your User ID"
              maxLength={20}
              {...registerUser("userId")}
              onInput={(e) => onlyAlphaNumeric(e)}
            />
            <p className="forget-link">
              <span>{userError?.userId?.message}</span>
              <Link to="/">{Constants.Back_Login}</Link>
            </p>

            {/* <!-- submit btn --> */}
            <button className="form-submit" type="submit">
              {Constants.Submit}
            </button>
          </form>
        )}

        {/* {"a" == "a" && } */}
      </div>
    </>
  );
}

export default ForgetTelePasswordForm;
